import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {JwtService} from 'mclane-webauth-lib';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {LoadingIndicatorHelper} from '~/app/shared/helpers/loading-indicator-helper';
import {ProfileService} from '~/app/core/common/services/profile.service';
import {ProfileCategoriesService} from '~/app/core/common/services/profile-categories.service';

@Injectable({
    providedIn: 'root'
})
export class ItemsResolver  {
    constructor(private jwtService: JwtService, private storeListService: StoreListService,
                private loadingIndicatorHelper: LoadingIndicatorHelper, private router: Router, private profileService: ProfileService) { }
    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.loadingIndicatorHelper.show('');
        const pickedCustomerId = await this.storeListService.pickedCustomerIdVerify();
        await this.profileService.downloadProfileItems(pickedCustomerId.toString(), 'A');

        // TODO if Store selection changed, update categories when store changed

        this.loadingIndicatorHelper.hide();
    }
}
